import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    '@global': {
        html: {
            fontSize: theme.typography.fontSize,
        },
        body: {
            fontFamily: theme.typography.fontFamily,
        },
        strong: {
            fontWeight: 500,
        },
        button: {
            fontFamily: theme.typography.fontFamily,
        },
    },
    // Casting to `any` because the createStyles type doesn't support arrays but in actually does
    '@font-face': theme.fontFaces,
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        color: theme.palette.text.primary,
        fontSize: theme.fontSizes.md,
    },
});
export default styles;
//# sourceMappingURL=App.styles.js.map